import * as types from "./actionType";

const initialState = {
  dealerStatus: false,
  dealers: [],
  dealerCount: 0,
  countryStatus: false,
  countries: [],
  stateStatus: false,
  states: [],
  cityStatus: false,
  cities: [],
  createBranchStatus: false,
  dealerDataStatus: false,
  dealerData: null,
  dealerBranchDataStatus: false,
  dealerBranchData: [],
  countryBranchStatus: false,
  countriesBranch: [],
  stateBranchStatus: false,
  statesBranch: [],
  cityBranchStatus: false,
  citiesBranch: [],
};

function dealerReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ALL_DEALER:
      return {
        ...state,
        dealerStatus: true,
      };
    case types.FETCH_ALL_DEALER_SUCCESS: {
      return {
        ...state,
        dealerStatus: false,
        dealers: [...state.dealers, ...action.payload],
        dealerCount: action.count,
      };
    }
    case types.FETCH_ALL_DEALER_FAILED: {
      return {
        ...state,
        dealerStatus: false,
        dealers: [],
      };
    }

    case types.FETCH_COUNTRY:
      return {
        ...state,
        countryStatus: true,
        countries: [],
      };
    case types.FETCH_COUNTRY_SUCCESS: {
      return {
        ...state,
        countryStatus: false,
        countries: action.payload,
      };
    }
    case types.FETCH_COUNTRY_FAILED: {
      return {
        ...state,
        countryStatus: false,
        countries: [],
      };
    }

    case types.FETCH_STATE:
      return {
        ...state,
        stateStatus: true,
        states: [],
      };
    case types.FETCH_STATE_SUCCESS: {
      return {
        ...state,
        stateStatus: false,
        states: action.payload,
      };
    }
    case types.FETCH_STATE_FAILED: {
      return {
        ...state,
        stateStatus: false,
        states: [],
      };
    }

    case types.FETCH_CITY:
      return {
        ...state,
        cityStatus: true,
        cities: [],
      };
    case types.FETCH_CITY_SUCCESS: {
      return {
        ...state,
        cityStatus: false,
        cities: action.payload,
      };
    }
    case types.FETCH_CITY_FAILED: {
      return {
        ...state,
        cityStatus: false,
        cities: [],
      };
    }

    case types.CREATE_BRANCH:
      return {
        ...state,
        createBranchStatus: true,
      };
    case types.CREATE_BRANCH_SUCCESS: {
      return {
        ...state,
        createBranchStatus: false,
      };
    }
    case types.CREATE_BRANCH_FAILED: {
      return {
        ...state,
        createBranchStatus: false,
      };
    }

    case types.FETCH_SINGLE_DEALER:
      return {
        ...state,
        dealerDataStatus: true,
        dealerData: null,
      };
    case types.FETCH_SINGLE_DEALER_SUCCESS: {
      return {
        ...state,
        dealerDataStatus: false,
        dealerData: action.payload,
      };
    }
    case types.FETCH_SINGLE_DEALER_FAILED: {
      return {
        ...state,
        dealerDataStatus: false,
        dealerData: null,
      };
    }
    case types.FETCH_DEALER_BRANCH:
      return {
        ...state,
        dealerBranchDataStatus: true,
        dealerBranchData: [],
      };
    case types.FETCH_DEALER_BRANCH_SUCCESS: {
      return {
        ...state,
        dealerBranchDataStatus: false,
        dealerBranchData: action.payload,
      };
    }
    case types.FETCH_DEALER_BRANCH_FAILED: {
      return {
        ...state,
        dealerBranchDataStatus: false,
        dealerBranchData: [],
      };
    }

    case types.FETCH_COUNTRY_BRANCH:
      return {
        ...state,
        countryBranchStatus: true,
        countriesBranch: [],
      };
    case types.FETCH_COUNTRY_BRANCH_SUCCESS: {
      return {
        ...state,
        countryBranchStatus: false,
        countriesBranch: action.payload,
      };
    }
    case types.FETCH_COUNTRY_BRANCH_FAILED: {
      return {
        ...state,
        countryBranchStatus: false,
        countriesBranch: [],
      };
    }

    case types.FETCH_STATE_BRANCH:
      return {
        ...state,
        stateBranchStatus: true,
        statesBranch: [],
      };
    case types.FETCH_STATE_BRANCHSUCCESS: {
      return {
        ...state,
        stateBranchStatus: false,
        statesBranch: action.payload,
      };
    }
    case types.FETCH_STATE_BRANCHFAILED: {
      return {
        ...state,
        stateBranchStatus: false,
        statesBranch: [],
      };
    }

    case types.FETCH_CITY_BRANCH:
      return {
        ...state,
        cityBranchStatus: true,
        citiesBranch: [],
      };
    case types.FETCH_CITY_BRANCHSUCCESS: {
      return {
        ...state,
        cityBranchStatus: false,
        citiesBranch: action.payload,
      };
    }
    case types.FETCH_CITY_BRANCHFAILED: {
      return {
        ...state,
        cityBranchStatus: false,
        citiesBranch: [],
      };
    }

    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        ...state,
        dealers: [],
        countryStatus: false,
        stateStatus: false,
        cityStatus: false,
        dealerCount: 0,
      };

    default:
      return state;
  }
}

export default dealerReducer;
